import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
// import { createLogger } from "redux-logger";
// import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { baseQuery } from "../services/baseQuery";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "sidebar"], // Only persist auth and sidebar state
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const logger = createLogger();

const store = configureStore({
  reducer: persistedReducer,
  // reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      baseQuery.middleware
    ),
});

export const persistor = persistStore(store);

export default store;
